/* eslint-disable react/jsx-no-bind */
import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import {connect} from 'react-redux';
import * as browserCheck from '../../utils/browserCheck.js';
import ContactService from '../../services/contactService';
import urls from '../../constants/urls.js';
import Loading from '../common/Loading';
import * as qs from 'query-string';
import * as urlUtils from '../../utils/urlUtils';


class ReportSpam extends React.Component {

    constructor(props, context) {
        super(props, context);       
        this.reportSpam = this.reportSpam.bind(this);
        const params = qs.parse(this.props.location.search);
        const roleID = params.roleID;
        const spamType = params.spamType;
        const id = params.id;
        const returnUrl = params.returnUrl;
        this.state = {
            roleID,
            spamType,
            id,
            returnUrl
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
         this.reportSpam();
    }

    reportSpam() {
        event.preventDefault();        
        ContactService.reportSpam(this.state.roleID, this.state.spamType, this.state.id)
            .then(result => {
                
            })
            .catch(error => {
                
            });       
    }

    render() {
        return (
            <div className="main">
                <MetaTags>       
                    <title>Report Spam - LoudUp</title>  
                    <meta name="robots" content="noindex" />
                </MetaTags>  
                <div className="container">
                    <div className="block-inner">
                        <div className="row">
                            <div className="col-md-12">
                                <article className="body-copy minimal-height">
                                    <header>
                                        <h1 className="section-alt">Spam Reported</h1>
                                    </header>
                                    <div className="body-narrow">
                                        <p style={{color:"#777"}}>Thank you for bringing this to our attention! We will investigate right away!</p>
                                        <br />
                                        {
                                            this.state.returnUrl && !urlUtils.isExternalUrl(this.state.returnUrl, this.props.location) ?
                                                <React.Fragment>
                                                    <Link to={this.state.returnUrl}>Return to Previous Page</Link> 
                                                    <br />
                                                    <br />
                                                </React.Fragment>
                                            : null
                                        }
                                        <Link to="/">Return to Homepage</Link>
                                    </div>
                                </article>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ReportSpam.propTypes = {
    location: PropTypes.object.isRequired
};

export default ReportSpam;